import type {
  MissingField,
  PendingStrandLossWarning,
  Process,
} from "../../models/caster.models";
import { isPreviousHeatWarning } from "./getPendingStrandLossWarnings";
import { getStrandLossMissingFields } from "./getStrandLossMissingFields";

export const getBannerMissingFields = (
  process: Process,
  currentHeatMissingFields: MissingField[],
  warnings: PendingStrandLossWarning[],
): MissingField[] => [
  ...getStrandLossMissingFields(
    process,
    warnings.filter(isPreviousHeatWarning),
  ),
  ...currentHeatMissingFields,
  ...getStrandLossMissingFields(
    process,
    warnings.filter((warning) => !isPreviousHeatWarning(warning)),
  ),
];
